import React, { useState, useEffect } from 'react';
import { getTicketReferences } from '../../../api/ticketReferences';

const STATUS_COLORS = {
  open: '#94a3b8',
  in_progress: '#3b82f6',
  completed: '#22c55e',
  closed: '#6b7280',
};

const TicketReferences = ({ ticketId, ticketNo, companyId, onTicketClick, refreshKey = 0 }) => {
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ticketId || !ticketNo || !companyId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      const { data } = await getTicketReferences(ticketId, ticketNo, companyId);
      if (!cancelled) {
        setReferences(data || []);
        setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [ticketId, ticketNo, companyId, refreshKey]);

  if (loading || references.length === 0) return null;

  return (
    <div className="sidebar-section">
      <div className="section-label">關聯 Ticket</div>
      <div className="reference-list">
        {references.map((ref) => (
          <button
            key={ref.id}
            className="reference-item"
            onClick={() => onTicketClick?.(ref.ticket_no)}
          >
            <span
              className="ref-status-dot"
              style={{ backgroundColor: STATUS_COLORS[ref.status] || '#94a3b8' }}
            />
            <span className="ref-ticket-no">#{ref.ticket_no}</span>
            <span className="ref-title">{ref.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TicketReferences;
